import { Outlet } from 'react-router-dom';

export default function Miscellaneous() {
    return (
        <Outlet />
    )
}
